import { DetallsProps } from './Detalls.types';
import __isEmpty from 'lodash/isEmpty';
import styles from './detalls.module.scss';

const Detalls = (props: Readonly<DetallsProps>) => {
    const { items } = props;

    if (__isEmpty(items)) return null;

    return (
        <div className={styles.detalls}>
            {items?.map((item, index) => (
                <details key={index} className={item.className || ''}>
                    <summary>{item.summary}</summary>
                    <div dangerouslySetInnerHTML={{ __html: item.content }} />
                </details>
            ))}
        </div>
    );
};

export default Detalls;
